import React from 'react'
import "./LoaderComponent.css";

const LoaderComponent = () => {
    return (
        <div id="loading-bar-spinner" class="spinner"><div class="spinner-icon"></div></div>
    )
}

export default LoaderComponent